// Product categories data with default images
export const productCategories = {
  pillows: {
    name: 'Pillows',
    description: 'Premium pillows for restful sleep - Memory Foam, Micro Fiber & more',
    image: '/category-images/pillows.png',
    count: 25,
    brands: ['Sleepwell', 'Recron', 'Kurlon'],
    defaultProductImage: '/category-images/pillows.png',
  },
  cushions: {
    name: 'Cushions',
    description: 'Comfortable cushions in all sizes - Custom sizes available',
    image: '/generated-images/pillow-recron-plush/pillow-recron-plush-1.png',
    count: 15,
    brands: ['Various'],
    defaultProductImage: '/generated-images/pillow-recron-plush/pillow-recron-plush-1.png',
  },
  bolsters: {
    name: 'Bolsters & Covers',
    description: 'Bolsters and bolster covers for complete comfort',
    image: '/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-1.png',
    count: 10,
    brands: ['Various'],
    defaultProductImage: '/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-1.png',
  },
  bedsheets: {
    name: 'Bedsheets',
    description: 'Elegant bedsheets in premium cotton - Single & Double Bed',
    image: '/category-images/bedsheets.png',
    count: 30,
    brands: ['myTrident', 'Bombay Dyeing', 'Classic Home'],
    defaultProductImage: '/category-images/bedsheets.png',
  },
  towels: {
    name: 'Towels',
    description: 'Bath, Hand, Face & Kitchen towels from premium brands',
    image: '/category-images/towels.png',
    count: 25,
    brands: ['myTrident', 'Bombay Dyeing'],
    defaultProductImage: '/category-images/towels.png',
  },
  mattresses: {
    name: 'Mattresses',
    description: 'Premium mattresses from top brands for perfect sleep',
    image: '/category-images/mattresses.png',
    count: 70,
    brands: ['Eclipse Mattress', 'Sleepwell', 'King Koil', 'Kurlon', 'Springwel'],
    defaultProductImage: '/category-images/mattresses.png',
  },
  blankets: {
    name: 'Blankets & Comforters',
    description: 'Warm blankets, comforters and dohars for all seasons',
    image: '/category-images/blankets.png',
    count: 20,
    brands: ['Signature', 'Golden UNO', 'Bombay Dyeing'],
    defaultProductImage: '/category-images/blankets.png',
  },
  mats: {
    name: 'Mats',
    description: 'Door mats, bath mats, shower mats, yoga mats & more',
    image: '/category-images/mats.png',
    count: 25,
    brands: ['Obsession', 'Various'],
    defaultProductImage: '/category-images/mats.png',
  },
  tableMats: {
    name: 'Table Mats',
    description: 'Elegant table mats for dining and decoration',
    image: '/generated-images/mat-brown-coir/mat-brown-coir-1.png',
    count: 10,
    brands: ['Various'],
    defaultProductImage: '/generated-images/mat-brown-coir/mat-brown-coir-1.png',
  },
  babyProducts: {
    name: 'Baby Products',
    description: 'Baby dry sheets and baby care essentials',
    image: '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-1.png',
    count: 5,
    brands: ['Various'],
    defaultProductImage: '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-1.png',
  },
  sofaProducts: {
    name: 'Sofa Products',
    description: 'Sofa cushions and sofa materials',
    image: '/generated-images/pillow-recron-elita/pillow-recron-elita-1.png',
    count: 15,
    brands: ['Various'],
    defaultProductImage: '/generated-images/pillow-recron-elita/pillow-recron-elita-1.png',
  },
};

// Placeholder image for products without images
export const PLACEHOLDER_IMAGE = '/category-images/mattresses.png';

// ==================== PILLOWS ====================
export const pillowProducts = [
  { 
    id: 'pillow-micro-fiber',
    name: 'Micro Fiber Pillow', 
    type: 'Micro Fiber', 
    brand: 'Premium', 
    bestseller: true,
    category: 'pillows',
    description: 'Ultra-soft micro fiber pillow that provides excellent support and comfort. Hypoallergenic and perfect for all sleeping positions.',
    features: ['Micro Fiber Fill', 'Hypoallergenic', 'Soft & Fluffy', 'Machine Washable'],
    images: [
      '/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-1.png',
      '/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-2.png',
      '/category-images/pillows.png'
    ]
  },
  { 
    id: 'pillow-polyfill',
    name: 'Polyfill Pillow', 
    type: 'Polyfill', 
    brand: 'Premium', 
    bestseller: false,
    category: 'pillows',
    description: 'Classic polyfill pillow offering medium support and lasting comfort. Affordable quality for everyday use.',
    features: ['Polyfill Material', 'Medium Support', 'Durable', 'Easy Care'],
    images: [
      '/generated-images/pillow-recron-superia/pillow-recron-superia-1.png',
      '/generated-images/pillow-recron-superia/pillow-recron-superia-2.png',
      '/category-images/pillows.png'
    ]
  },
  { 
    id: 'pillow-memory-foam',
    name: 'Memory Foam Pillow', 
    type: 'Memory Foam', 
    brand: 'Sleepwell', 
    bestseller: true,
    category: 'pillows',
    description: 'Premium memory foam pillow that contours to your head and neck for optimal support. Ideal for neck pain relief.',
    features: ['Memory Foam', 'Contour Support', 'Pressure Relief', 'Removable Cover'],
    images: [
      '/generated-images/pillow-sleepwell-memory/pillow-sleepwell-memory-1.png',
      '/generated-images/pillow-sleepwell-memory/pillow-sleepwell-memory-2.png',
      '/generated-images/pillow-sleepwell-memory/pillow-sleepwell-memory-3.png'
    ]
  },
  { 
    id: 'pillow-contour-memory-foam',
    name: 'Contour Memory Foam Pillow', 
    type: 'Contour Memory Foam', 
    brand: 'Sleepwell', 
    bestseller: true,
    category: 'pillows',
    description: 'Ergonomically designed contour memory foam pillow for superior cervical support. Perfect for side and back sleepers.',
    features: ['Ergonomic Design', 'Cervical Support', 'Spine Alignment', 'Breathable Cover'],
    images: [
      '/generated-images/pillow-sleepwell-memory/pillow-sleepwell-memory-2.png',
      '/generated-images/pillow-sleepwell-memory/pillow-sleepwell-memory-3.png',
      '/generated-images/pillow-sleepwell-memory/pillow-sleepwell-memory-1.png'
    ]
  },
  { 
    id: 'pillow-ultra-thin-memory-foam',
    name: 'Ultra Thin Memory Foam Pillow', 
    type: 'Ultra Thin Memory Foam', 
    brand: 'Premium', 
    bestseller: false,
    category: 'pillows',
    description: 'Slim profile memory foam pillow for stomach sleepers and those who prefer low loft pillows.',
    features: ['Ultra Thin Profile', 'Memory Foam', 'Stomach Sleeper Friendly', 'Cooling Gel'],
    images: [
      '/generated-images/pillow-sleepwell-memory/pillow-sleepwell-memory-3.png',
      '/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-1.png',
      '/category-images/pillows.png'
    ]
  },
  { 
    id: 'pillow-pu-foam',
    name: 'PU Foam Pillow', 
    type: 'PU Foam', 
    brand: 'Kurlon', 
    bestseller: false,
    category: 'pillows',
    description: 'High-density PU foam pillow offering firm support. Long-lasting and maintains shape over time.',
    features: ['PU Foam', 'Firm Support', 'Shape Retention', 'Durable'],
    images: ['/generated-images/pillow-recron-elita/pillow-recron-elita-1.png', '/generated-images/pillow-recron-elita/pillow-recron-elita-2.png', '/generated-images/pillow-recron-elita/pillow-recron-elita-3.png']
  },
  { 
    id: 'pillow-recron-certified',
    name: 'Recron Certified Pillow', 
    type: 'Recron Fiber', 
    brand: 'Recron', 
    bestseller: true,
    category: 'pillows',
    description: 'Recron certified fiber pillow with superior softness and bounce. Trusted quality for restful sleep.',
    features: ['Recron Certified', 'Superior Softness', 'Bouncy Feel', 'Anti-Allergic'],
    images: ['/generated-images/pillow-recron-superia/pillow-recron-superia-1.png', '/generated-images/pillow-recron-superia/pillow-recron-superia-2.png', '/generated-images/pillow-recron-superia/pillow-recron-superia-3.png']
  },
];

// ==================== CUSHIONS ====================
export const cushionProducts = [
  { 
    id: 'cushion-12x12',
    name: 'Cushion 12x12 inches', 
    type: '12x12', 
    brand: 'Various', 
    bestseller: false,
    category: 'cushions',
    description: 'Compact 12x12 inch cushion perfect for accent decoration and small spaces.',
    features: ['12x12 inches', 'Compact Size', 'Decorative', 'Multiple Colors'],
    images: ['/generated-images/pillow-recron-plush/pillow-recron-plush-1.png', '/generated-images/pillow-recron-plush/pillow-recron-plush-2.png', '/generated-images/pillow-recron-plush/pillow-recron-plush-3.png']
  },
  { 
    id: 'cushion-16x16',
    name: 'Cushion 16x16 inches', 
    type: '16x16', 
    brand: 'Various', 
    bestseller: true,
    category: 'cushions',
    description: 'Standard 16x16 inch cushion ideal for chairs and sofas. Comfortable and versatile.',
    features: ['16x16 inches', 'Standard Size', 'Versatile', 'Comfortable'],
    images: ['/generated-images/pillow-recron-elita/pillow-recron-elita-1.png', '/generated-images/pillow-recron-elita/pillow-recron-elita-2.png', '/generated-images/pillow-recron-elita/pillow-recron-elita-3.png']
  },
  { 
    id: 'cushion-18x18',
    name: 'Cushion 18x18 inches', 
    type: '18x18', 
    brand: 'Various', 
    bestseller: true,
    category: 'cushions',
    description: 'Popular 18x18 inch cushion providing excellent comfort for living room furniture.',
    features: ['18x18 inches', 'Popular Size', 'Living Room', 'Plush Fill'],
    images: ['/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-1.png', '/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-2.png', '/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-3.png']
  },
  { 
    id: 'cushion-20x20',
    name: 'Cushion 20x20 inches', 
    type: '20x20', 
    brand: 'Various', 
    bestseller: false,
    category: 'cushions',
    description: 'Large 20x20 inch cushion for maximum comfort. Perfect for floor seating and large sofas.',
    features: ['20x20 inches', 'Large Size', 'Floor Seating', 'Extra Comfort'],
    images: ['/generated-images/pillow-recron-superia/pillow-recron-superia-1.png', '/generated-images/pillow-recron-superia/pillow-recron-superia-2.png', '/generated-images/pillow-recron-superia/pillow-recron-superia-3.png']
  },
  { 
    id: 'cushion-custom',
    name: 'Custom Size Cushion', 
    type: 'Custom', 
    brand: 'Various', 
    bestseller: false,
    category: 'cushions',
    description: 'Custom size cushions made to your exact specifications. Contact us for custom orders.',
    features: ['Custom Size', 'Made to Order', 'Any Dimension', 'Special Requests'],
    images: ['/generated-images/pillow-recron-plush/pillow-recron-plush-2.png', '/generated-images/pillow-recron-plush/pillow-recron-plush-1.png', '/generated-images/pillow-recron-plush/pillow-recron-plush-3.png']
  },
];

// ==================== BOLSTERS ====================
export const bolsterProducts = [
  { 
    id: 'bolster-standard',
    name: 'Standard Bolster', 
    type: 'Standard', 
    brand: 'Premium', 
    bestseller: true,
    category: 'bolsters',
    description: 'Traditional cylindrical bolster pillow for back support and comfortable sleeping.',
    features: ['Cylindrical Shape', 'Back Support', 'Traditional Design', 'Cotton Cover'],
    images: ['/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-1.png', '/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-2.png', '/generated-images/pillow-sleepwell-norma/pillow-sleepwell-norma-3.png']
  },
  { 
    id: 'bolster-large',
    name: 'Large Bolster', 
    type: 'Large', 
    brand: 'Premium', 
    bestseller: false,
    category: 'bolsters',
    description: 'Extra-large bolster for maximum support and comfort during sleep or relaxation.',
    features: ['Extra Large', 'Maximum Support', 'Premium Fill', 'Durable'],
    images: ['/generated-images/pillow-recron-elita/pillow-recron-elita-1.png', '/generated-images/pillow-recron-elita/pillow-recron-elita-2.png', '/generated-images/pillow-recron-elita/pillow-recron-elita-3.png']
  },
  { 
    id: 'bolster-cover-printed',
    name: 'Printed Bolster Cover', 
    type: 'Cover', 
    brand: 'Various', 
    bestseller: true,
    category: 'bolsters',
    description: 'Decorative printed bolster cover with zipper closure. Easy to wash and change.',
    features: ['Printed Design', 'Zipper Closure', 'Washable', 'Multiple Patterns'],
    images: ['/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-1.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-2.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-3.png']
  },
  { 
    id: 'bolster-cover-plain',
    name: 'Plain Bolster Cover', 
    type: 'Cover', 
    brand: 'Various', 
    bestseller: false,
    category: 'bolsters',
    description: 'Simple plain bolster cover in solid colors. Classic and elegant for any bedroom.',
    features: ['Plain Design', 'Solid Colors', 'Elegant', 'Easy Care'],
    images: ['/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-1.png', '/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-2.png', '/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-3.png']
  },
];

// ==================== BEDSHEETS ====================
export const bedsheetProducts = [
  { 
    id: 'bedsheet-mytrident-premium',
    name: 'myTrident Premium Bedsheet', 
    type: 'Double Bed', 
    brand: 'myTrident', 
    bestseller: true,
    category: 'bedsheets',
    description: 'Premium quality myTrident bedsheet with elegant design and superior cotton fabric.',
    features: ['100% Cotton', 'Premium Quality', 'Color Fast', 'Pillow Covers Included'],
    images: ['/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-1.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-2.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-3.png']
  },
  { 
    id: 'bedsheet-super-soft-sb',
    name: 'Super Soft S/B Bedsheet', 
    type: 'Single Bed', 
    brand: 'Premium', 
    bestseller: true,
    category: 'bedsheets',
    description: 'Super soft single bed bedsheet with silky smooth finish for ultimate comfort.',
    features: ['Super Soft', 'Single Bed', 'Silky Finish', 'Breathable'],
    images: ['/generated-images/bedsheet-mytrident-utsav/bedsheet-mytrident-utsav-1.png', '/generated-images/bedsheet-mytrident-utsav/bedsheet-mytrident-utsav-2.png', '/generated-images/bedsheet-mytrident-utsav/bedsheet-mytrident-utsav-3.png']
  },
  { 
    id: 'bedsheet-super-count-sb',
    name: 'Super Count S/B Bedsheet', 
    type: 'Single Bed', 
    brand: 'Premium', 
    bestseller: false,
    category: 'bedsheets',
    description: 'High thread count single bed bedsheet for luxurious sleeping experience.',
    features: ['High Thread Count', 'Single Bed', 'Luxury Feel', 'Durable'],
    images: ['/generated-images/bedsheet-classic-home-premium/bedsheet-classic-home-premium-1.png', '/generated-images/bedsheet-classic-home-premium/bedsheet-classic-home-premium-2.png', '/generated-images/bedsheet-classic-home-premium/bedsheet-classic-home-premium-3.png']
  },
  { 
    id: 'bedsheet-handloom',
    name: 'Handloom Bedsheet', 
    type: 'Double Bed', 
    brand: 'Handloom', 
    bestseller: false,
    category: 'bedsheets',
    description: 'Traditional handloom bedsheet with authentic weaving patterns. Artisan crafted.',
    features: ['Handloom Woven', 'Traditional', 'Artisan Made', 'Natural Fibers'],
    images: ['/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-2.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-1.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-3.png']
  },
  { 
    id: 'bedsheet-meridian-db',
    name: 'Meridian D/B Bedsheet', 
    type: 'Double Bed', 
    brand: 'Meridian', 
    bestseller: true,
    category: 'bedsheets',
    description: 'Meridian double bed bedsheet with contemporary designs and premium cotton.',
    features: ['Contemporary Design', 'Double Bed', 'Premium Cotton', 'Fade Resistant'],
    images: ['/generated-images/bedsheet-mytrident-utsav/bedsheet-mytrident-utsav-2.png', '/generated-images/bedsheet-mytrident-utsav/bedsheet-mytrident-utsav-1.png', '/generated-images/bedsheet-mytrident-utsav/bedsheet-mytrident-utsav-3.png']
  },
  { 
    id: 'bedsheet-calvin-db',
    name: 'Calvin D/B Bedsheet', 
    type: 'Double Bed', 
    brand: 'Calvin', 
    bestseller: false,
    category: 'bedsheets',
    description: 'Calvin collection double bed bedsheet with modern patterns and soft texture.',
    features: ['Modern Patterns', 'Double Bed', 'Soft Texture', 'Easy Wash'],
    images: ['/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-1.png', '/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-2.png', '/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-3.png']
  },
  { 
    id: 'bedsheet-high-living-db',
    name: 'High Living D/B Bedsheet', 
    type: 'Double Bed', 
    brand: 'High Living', 
    bestseller: true,
    category: 'bedsheets',
    description: 'High Living luxury double bed bedsheet for premium bedroom experience.',
    features: ['Luxury Quality', 'Double Bed', 'Premium Finish', 'Rich Colors'],
    images: ['/generated-images/bedsheet-classic-home-premium/bedsheet-classic-home-premium-2.png', '/generated-images/bedsheet-classic-home-premium/bedsheet-classic-home-premium-1.png', '/generated-images/bedsheet-classic-home-premium/bedsheet-classic-home-premium-3.png']
  },
  { 
    id: 'bedsheet-bombay-dyeing',
    name: 'Bombay Dyeing Bedsheet', 
    type: 'Double Bed', 
    brand: 'Bombay Dyeing', 
    bestseller: true,
    category: 'bedsheets',
    description: 'Classic Bombay Dyeing bedsheet with trusted quality and timeless designs.',
    features: ['Trusted Brand', 'Classic Quality', 'Timeless Design', 'Long Lasting'],
    images: ['/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-2.png', '/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-1.png', '/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-3.png']
  },
  { 
    id: 'bedsheet-classic-home-white-stripes',
    name: 'Classic Home White Stripes Bedsheet', 
    type: 'Double Bed', 
    brand: 'Classic Home', 
    bestseller: false,
    category: 'bedsheets',
    description: 'Elegant white striped bedsheet from Classic Home collection for sophisticated bedrooms.',
    features: ['White Stripes', 'Elegant Design', 'Sophisticated', 'Premium Cotton'],
    images: ['/generated-images/bedsheet-classic-home-premium/bedsheet-classic-home-premium-1.png', '/generated-images/bedsheet-classic-home-premium/bedsheet-classic-home-premium-2.png', '/generated-images/bedsheet-classic-home-premium/bedsheet-classic-home-premium-3.png']
  },
];

// ==================== TOWELS ====================
export const towelProducts = [
  { 
    id: 'towel-mytrident-bath-large',
    name: 'myTrident Bath Towel (75x150cm)', 
    type: 'Bath Towel', 
    brand: 'myTrident', 
    bestseller: true,
    category: 'towels',
    description: 'Large myTrident bath towel with superior absorbency and soft cotton feel.',
    features: ['75x150cm', 'Super Absorbent', '100% Cotton', 'Quick Dry'],
    images: ['/generated-images/towel-mytrident-soft/towel-mytrident-soft-1.png', '/generated-images/towel-mytrident-soft/towel-mytrident-soft-2.png', '/generated-images/towel-mytrident-soft/towel-mytrident-soft-3.png']
  },
  { 
    id: 'towel-mytrident-medium-bath',
    name: 'myTrident Medium/Women Bath Towel', 
    type: 'Bath Towel', 
    brand: 'myTrident', 
    bestseller: true,
    category: 'towels',
    description: 'Medium size bath towel perfect for women and everyday use.',
    features: ['Medium Size', 'Lightweight', 'Soft Touch', 'Ideal for Daily Use'],
    images: ['/generated-images/towel-mytrident-soft/towel-mytrident-soft-2.png', '/generated-images/towel-mytrident-soft/towel-mytrident-soft-1.png', '/generated-images/towel-mytrident-soft/towel-mytrident-soft-3.png']
  },
  { 
    id: 'towel-hand-40x60',
    name: 'Hand Towel (40x60)', 
    type: 'Hand Towel', 
    brand: 'myTrident', 
    bestseller: false,
    category: 'towels',
    description: 'Compact hand towel for bathroom and kitchen use. Highly absorbent.',
    features: ['40x60cm', 'Compact Size', 'Multi-Purpose', 'Absorbent'],
    images: ['/generated-images/towel-mytrident-hand/towel-mytrident-hand-1.png', '/generated-images/towel-mytrident-hand/towel-mytrident-hand-2.png', '/generated-images/towel-mytrident-hand/towel-mytrident-hand-3.png']
  },
  { 
    id: 'towel-face',
    name: 'Face Towel', 
    type: 'Face Towel', 
    brand: 'Various', 
    bestseller: false,
    category: 'towels',
    description: 'Soft face towel for gentle facial care. Perfect for daily skincare routine.',
    features: ['Soft Fabric', 'Gentle on Skin', 'Face Care', 'Pack Available'],
    images: ['/generated-images/towel-mytrident-hand/towel-mytrident-hand-2.png', '/generated-images/towel-mytrident-hand/towel-mytrident-hand-1.png', '/generated-images/towel-mytrident-hand/towel-mytrident-hand-3.png']
  },
  { 
    id: 'towel-kitchen',
    name: 'Kitchen Towel', 
    type: 'Kitchen Towel', 
    brand: 'Various', 
    bestseller: false,
    category: 'towels',
    description: 'Absorbent kitchen towel for cooking and cleaning. Essential kitchen accessory.',
    features: ['Kitchen Use', 'Absorbent', 'Durable', 'Easy Wash'],
    images: ['/generated-images/towel-mytrident-hand/towel-mytrident-hand-3.png', '/generated-images/towel-mytrident-hand/towel-mytrident-hand-1.png', '/generated-images/towel-mytrident-hand/towel-mytrident-hand-2.png']
  },
  { 
    id: 'towel-waffle-south',
    name: 'Waffle / South Towel', 
    type: 'Waffle Towel', 
    brand: 'Various', 
    bestseller: false,
    category: 'towels',
    description: 'Traditional waffle weave towel with excellent absorbency and quick-dry properties.',
    features: ['Waffle Weave', 'Quick Dry', 'Lightweight', 'Traditional Style'],
    images: ['/generated-images/towel-bombay-dyeing-ultra/towel-bombay-dyeing-ultra-1.png', '/generated-images/towel-bombay-dyeing-ultra/towel-bombay-dyeing-ultra-2.png', '/generated-images/towel-bombay-dyeing-ultra/towel-bombay-dyeing-ultra-3.png']
  },
  { 
    id: 'towel-bombay-dyeing',
    name: 'Bombay Dyeing Towel', 
    type: 'Bath Towel', 
    brand: 'Bombay Dyeing', 
    bestseller: true,
    category: 'towels',
    description: 'Premium Bombay Dyeing towel with superior quality and lasting softness.',
    features: ['Premium Brand', 'Superior Quality', 'Long Lasting', 'Soft Feel'],
    images: ['/generated-images/towel-bombay-dyeing-ultra/towel-bombay-dyeing-ultra-2.png', '/generated-images/towel-bombay-dyeing-ultra/towel-bombay-dyeing-ultra-1.png', '/generated-images/towel-bombay-dyeing-ultra/towel-bombay-dyeing-ultra-3.png']
  },
];

// ==================== MATTRESSES ====================
export const mattressProducts = [
  { 
    id: 'mattress-sleepwell-ortho-pro',
    name: 'Sleepwell Ortho Pro Spring', 
    type: 'Orthopedic', 
    brand: 'Sleepwell', 
    bestseller: true,
    category: 'mattresses',
    description: 'Experience superior orthopedic support with the Sleepwell Ortho Pro Spring mattress.',
    features: ['Orthopedic Support', 'Spring Technology', 'Anti-Dust Mite', '10 Year Warranty'],
    images: ['/generated-images/mattress-sleepwell-ortho-pro/mattress-sleepwell-ortho-pro-1.png', '/generated-images/mattress-sleepwell-ortho-pro/mattress-sleepwell-ortho-pro-2.png', '/generated-images/mattress-sleepwell-ortho-pro/mattress-sleepwell-ortho-pro-3.png']
  },
  { 
    id: 'mattress-sleepwell-durafirm',
    name: 'Sleepwell Durafirm Luxury', 
    type: 'Memory Foam', 
    brand: 'Sleepwell', 
    bestseller: false,
    category: 'mattresses',
    description: 'The Sleepwell Durafirm Luxury combines firm support with plush comfort.',
    features: ['Memory Foam', 'Firm Support', 'Temperature Control', '7 Year Warranty'],
    images: ['/generated-images/mattress-sleepwell-durafirm/mattress-sleepwell-durafirm-1.png', '/generated-images/mattress-sleepwell-durafirm/mattress-sleepwell-durafirm-2.png', '/generated-images/mattress-sleepwell-durafirm/mattress-sleepwell-durafirm-3.png']
  },
  { 
    id: 'mattress-king-koil-grand',
    name: 'King Koil Grand Premium', 
    type: 'Luxury', 
    brand: 'King Koil', 
    bestseller: true,
    category: 'mattresses',
    description: 'Experience royal comfort with King Koil Grand Premium.',
    features: ['ICA Endorsed', 'Luxury Comfort', 'Edge Support', '15 Year Warranty'],
    images: ['/generated-images/mattress-king-koil-grand/mattress-king-koil-grand-1.png', '/generated-images/mattress-king-koil-grand/mattress-king-koil-grand-2.png', '/generated-images/mattress-king-koil-grand/mattress-king-koil-grand-3.png']
  },
  { 
    id: 'mattress-kurlon-dream',
    name: 'Kurlon Dream Sleep', 
    type: 'Foam', 
    brand: 'Kurlon', 
    bestseller: false,
    category: 'mattresses',
    description: 'Affordable comfort meets quality in the Kurlon Dream Sleep.',
    features: ['HD Foam', 'Affordable', 'Durable', '5 Year Warranty'],
    images: ['/generated-images/mattress-kurlon-dream/mattress-kurlon-dream-1.png', '/generated-images/mattress-kurlon-dream/mattress-kurlon-dream-2.png', '/generated-images/mattress-kurlon-dream/mattress-kurlon-dream-3.png']
  },
  // Eclipse Mattress Products
  { 
    id: 'eclipse-coil-on-coil',
    name: 'Coil On Coil', 
    type: 'Dual Spring', 
    brand: 'Eclipse Mattress', 
    bestseller: true,
    category: 'mattresses',
    description: 'Advanced dual spring technology combining 416 Bonnell Innersprings and 941 Pocketed Springs for optimal support.',
    features: ['416 Bonnell + 941 Pocketed Springs', 'Spinal Zone Technology', 'Life Edge Support', 'Allergen-Free 3D Fabric', '11" & 13" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page12_img01.webp',
      '/eclipse-products/patent/page13_img02.webp',
      '/eclipse-products/patent/page13_img04.webp'
    ]
  },
  { 
    id: 'eclipse-tiara-cool-gel',
    name: 'Tiara Cool Gel Series', 
    type: 'Memory Foam + Cool Gel', 
    brand: 'Eclipse Mattress', 
    bestseller: true,
    category: 'mattresses',
    description: 'Thermally neutral mattress with memory foam and cool gel. Dual-sided for winter and summer comfort.',
    features: ['Cool Gel Temperature Regulation', 'Memory Foam + Natural Latex', 'Pocketed Springs', 'Dual-Sided Comfort', '8" & 10" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page14_img01.webp',
      '/eclipse-products/patent/page15_img02.webp',
      '/eclipse-products/patent/page15_img04.webp'
    ]
  },
  { 
    id: 'eclipse-accolade-pt',
    name: 'Accolade PT Pocketed 5 Zone', 
    type: '5 Zone Support', 
    brand: 'Eclipse Mattress', 
    bestseller: true,
    category: 'mattresses',
    description: 'INBALANCE technology creates 5 distinct comfort zones. Endorsed by USA Chiropractic State Association.',
    features: ['5-Zone INBALANCE Technology', 'Spinal Zone Support', 'Foam-Encased Life Edge', 'Chiropractic Endorsed', '7" & 9" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page16_img01.webp',
      '/eclipse-products/patent/page17_img02.webp',
      '/eclipse-products/patent/page17_img04.webp'
    ]
  },
  { 
    id: 'eclipse-romance',
    name: 'Romance Mattress', 
    type: 'Customizable Firmness', 
    brand: 'Eclipse Mattress', 
    bestseller: false,
    category: 'mattresses',
    description: 'Natural Latex, Memory Foam, and HR Foam blend. Patented interchangeable layers for dual firmness.',
    features: ['Natural Latex + Memory Foam', 'Interchangeable Inner Layers', 'Dual Firmness Options', 'Pressure Point Relief', '6", 8" & 10" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page18_img01.webp',
      '/eclipse-products/patent/page19_img02.webp',
      '/eclipse-products/patent/page19_img13.webp'
    ]
  },
  { 
    id: 'eclipse-health-sense-et',
    name: 'Health Sense ET', 
    type: 'Euro Top', 
    brand: 'Eclipse Mattress', 
    bestseller: true,
    category: 'mattresses',
    description: '941 Pocketed Springs with Visco Memory Foam. Spinal Zone and Life Edge technologies for health.',
    features: ['941 Pocketed Springs', 'Visco Memory Foam', 'Spinal Zone Technology', 'Life Edge Support', '8" & 10" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page20_img02.webp',
      '/eclipse-products/patent/page21_img02.webp',
      '/eclipse-products/patent/page21_img13.webp'
    ]
  },
  { 
    id: 'eclipse-vienna-et',
    name: 'Vienna ET', 
    type: 'Euro Top Natural Latex', 
    brand: 'Eclipse Mattress', 
    bestseller: true,
    category: 'mattresses',
    description: '7-Zoned Natural Latex Euro-Top with Spinal Zone technology. Perfect for back and neck problems.',
    features: ['7-Zone Natural Latex Euro-Top', 'Back & Neck Support', '416 Bonnell Springs', 'Life Edge Technology', '8" & 10" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page22_img01.webp',
      '/eclipse-products/patent/page23_img02.webp',
      '/eclipse-products/patent/page23_img07.webp'
    ]
  },
  { 
    id: 'eclipse-natura-dreams',
    name: 'Natura Dreams', 
    type: '100% Latex', 
    brand: 'Eclipse Mattress', 
    bestseller: true,
    category: 'mattresses',
    description: '7-Zone 100% Belgian Talalay Latex. Hypoallergenic, breathable, eco-friendly with Tencel fabric.',
    features: ['100% Talalay Latex', '7-Zoned Support', 'Hypoallergenic & Breathable', 'Tencel Fabric', '6" & 8" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page26_img01.webp',
      '/eclipse-products/patent/page27_img02.webp',
      '/eclipse-products/patent/page27_img05.webp'
    ]
  },
  { 
    id: 'eclipse-harmony-edge',
    name: 'Harmony/EDGE', 
    type: 'Foam + Latex', 
    brand: 'Eclipse Mattress', 
    bestseller: false,
    category: 'mattresses',
    description: 'HR foam, Visco Memory Foam, and 100% latex top. Tencel fabric for anti-bacterial comfort.',
    features: ['HR Foam + Memory Foam + Latex', 'Tencel Fabric', 'Anti-Bacterial & Breathable', 'Eco-Friendly', '7" & 9" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page28_img01.webp',
      '/eclipse-products/patent/page29_img02.webp',
      '/eclipse-products/patent/page29_img04.webp'
    ]
  },
  { 
    id: 'eclipse-outlast',
    name: 'Outlast Mattress', 
    type: 'NASA Temperature Control', 
    brand: 'Eclipse Mattress', 
    bestseller: true,
    category: 'mattresses',
    description: 'NASA-developed Outlast fiber technology for optimal body temperature. Odor-free and breathable.',
    features: ['NASA Outlast Technology', 'Temperature Regulation', 'Visco Memory Foam', 'Odor-Free & Breathable', '6" & 8" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page30_img01.webp',
      '/eclipse-products/patent/page31_img02.webp',
      '/eclipse-products/patent/page31_img07.webp'
    ]
  },
  { 
    id: 'eclipse-harmony-ortho',
    name: 'Harmony/ORTHO', 
    type: 'Orthopedic', 
    brand: 'Eclipse Mattress', 
    bestseller: true,
    category: 'mattresses',
    description: 'Medically approved Orthobond Core with Memory Foam and 100% Latex. Both-side use for back pain.',
    features: ['Medically Approved Orthobond', 'Memory Foam + 100% Latex', 'Both-Side Use', 'High Back Support', '7" & 9" Thickness'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '72x66"', '72x72"', '75x30"', '75x36"', '75x42"', '75x48"', '75x60"', '75x66"', '75x72"'],
    images: [
      '/eclipse-products/patent/page32_img01.webp',
      '/eclipse-products/patent/page33_img02.webp',
      '/eclipse-products/patent/page33_img04.webp'
    ]
  },
  { 
    id: 'eclipse-luxury-suite',
    name: 'Luxury Suite',
    type: 'Premium Collection',
    brand: 'Eclipse Mattress',
    bestseller: true,
    category: 'mattresses',
    description: 'Premium luxury mattress with advanced spring system and plush comfort layers for ultimate sleep.',
    features: ['Premium Spring System', 'Plush Comfort Layers', 'Edge Support', 'Luxury Fabric', 'Multiple Thickness Options'],
    sizes: ['72x30"', '72x48"', '72x60"', '72x72"', '75x48"', '75x60"', '75x72"'],
    images: [
      '/eclipse-products/catalogue/page06_img01.webp',
      '/eclipse-products/catalogue/page07_img02.webp',
      '/eclipse-products/catalogue/page07_img10.webp'
    ]
  },
  { 
    id: 'eclipse-comfort-plus',
    name: 'Comfort Plus',
    type: 'Spring Mattress',
    brand: 'Eclipse Mattress',
    bestseller: false,
    category: 'mattresses',
    description: 'Balanced comfort mattress with spring support and foam layers for everyday restful sleep.',
    features: ['Bonnell Spring System', 'Foam Comfort Layer', 'Breathable Fabric', 'Value Pricing', '6" & 8" Available'],
    sizes: ['72x30"', '72x42"', '72x48"', '72x60"', '75x48"', '75x60"'],
    images: [
      '/eclipse-products/catalogue/page08_img02.webp',
      '/eclipse-products/catalogue/page07_img04.webp',
      '/eclipse-products/catalogue/page07_img06.webp'
    ]
  },
  { 
    id: 'eclipse-royal-comfort',
    name: 'Royal Comfort',
    type: 'Luxury Plush',
    brand: 'Eclipse Mattress',
    bestseller: true,
    category: 'mattresses',
    description: 'Royal comfort experience with multi-layer construction for superior pressure relief and support.',
    features: ['Multi-Layer Construction', 'Pressure Relief', 'Plush Top', 'Premium Quality', '8" & 10" Options'],
    sizes: ['72x48"', '72x60"', '72x72"', '75x48"', '75x60"', '75x72"'],
    images: [
      '/eclipse-products/catalogue/page10_img02.webp',
      '/eclipse-products/catalogue/page04_img02.webp',
      '/eclipse-products/catalogue/page04_img04.webp'
    ]
  },
  { 
    id: 'eclipse-premium-euro',
    name: 'Premium Euro Top',
    type: 'Euro Top',
    brand: 'Eclipse Mattress',
    bestseller: true,
    category: 'mattresses',
    description: 'Premium Euro-top design with enhanced comfort layers and superior edge-to-edge support.',
    features: ['Euro Top Design', 'Enhanced Comfort Layers', 'Edge-to-Edge Support', 'Premium Fabric', '10" & 12" Available'],
    sizes: ['72x48"', '72x60"', '72x72"', '75x60"', '75x72"', '78x72"'],
    images: [
      '/eclipse-products/catalogue/page12_img01.webp',
      '/eclipse-products/catalogue/page03_img02.webp',
      '/eclipse-products/catalogue/page03_img04.webp'
    ]
  },
  { 
    id: 'eclipse-deluxe-ortho',
    name: 'Deluxe Ortho',
    type: 'Orthopedic',
    brand: 'Eclipse Mattress',
    bestseller: true,
    category: 'mattresses',
    description: 'Orthopedic mattress with firm support for proper spine alignment and back health.',
    features: ['Orthopedic Support', 'Firm Comfort', 'Spine Alignment', 'Durable Construction', '6" & 8" Available'],
    sizes: ['72x30"', '72x36"', '72x42"', '72x48"', '72x60"', '75x48"', '75x60"'],
    images: [
      '/eclipse-products/catalogue/page14_img02.webp',
      '/eclipse-products/catalogue/page02_img02.webp',
      '/eclipse-products/catalogue/page07_img08.webp'
    ]
  },
  { 
    id: 'eclipse-spine-care',
    name: 'Spine Care',
    type: 'Orthopedic Support',
    brand: 'Eclipse Mattress',
    bestseller: true,
    category: 'mattresses',
    description: 'Specialized spine care mattress with targeted support zones for back pain relief.',
    features: ['Spine Care Technology', 'Targeted Support Zones', 'Pressure Relief', 'Firm Support', '7" & 9" Options'],
    sizes: ['72x36"', '72x48"', '72x60"', '72x72"', '75x48"', '75x60"', '75x72"'],
    images: [
      '/eclipse-products/catalogue/page16_img01.webp',
      '/eclipse-products/catalogue/page07_img09.webp',
      '/eclipse-products/catalogue/page07_img12.webp'
    ]
  },
  { 
    id: 'eclipse-cloud-comfort',
    name: 'Cloud Comfort',
    type: 'Plush Foam',
    brand: 'Eclipse Mattress',
    bestseller: false,
    category: 'mattresses',
    description: 'Cloud-like comfort with high-density foam layers for pressure-free sleeping experience.',
    features: ['High-Density Foam', 'Plush Comfort', 'Pressure Free', 'Soft Support', '6" & 8" Available'],
    sizes: ['72x30"', '72x42"', '72x48"', '72x60"', '75x48"', '75x60"'],
    images: [
      '/eclipse-products/catalogue/page18_img02.webp',
      '/eclipse-products/catalogue/page02_img02.webp',
      '/eclipse-products/catalogue/page01_img01.webp'
    ]
  },
  { 
    id: 'eclipse-bio-latex',
    name: 'Bio Latex Premium',
    type: 'Latex Foam',
    brand: 'Eclipse Mattress',
    bestseller: true,
    category: 'mattresses',
    description: 'USA technology bio latex foam with 60 density. Enhanced bounce back, resilience and breathability.',
    features: ['Bio Latex Foam USA', '60 Density', 'Enhanced Resilience', 'Pressure Relief', 'Breathable', '6" & 8" Options'],
    sizes: ['72x36"', '72x48"', '72x60"', '72x72"', '75x48"', '75x60"', '75x72"'],
    images: [
      '/eclipse-products/catalogue/page20_img01.webp',
      '/eclipse-products/catalogue/page04_img02.webp',
      '/eclipse-products/catalogue/page06_img01.webp'
    ]
  },
  { 
    id: 'eclipse-premium-spring',
    name: 'Premium Spring Collection',
    type: 'Spring System',
    brand: 'Eclipse Mattress',
    bestseller: true,
    category: 'mattresses',
    description: 'Premium spring collection with advanced coil system for optimal support and durability.',
    features: ['Premium Coil System', 'Advanced Support', 'Durable Construction', 'Comfort Layer', '8" & 10" Available'],
    sizes: ['72x48"', '72x60"', '72x72"', '75x48"', '75x60"', '75x72"', '78x72"'],
    images: [
      '/eclipse-products/catalogue/page22_img02.webp',
      '/eclipse-products/catalogue/page08_img02.webp',
      '/eclipse-products/catalogue/page10_img02.webp'
    ]
  },
  { 
    id: 'eclipse-ultra-comfort',
    name: 'Ultra Comfort',
    type: 'Memory Foam',
    brand: 'Eclipse Mattress',
    bestseller: false,
    category: 'mattresses',
    description: 'Ultra comfort memory foam mattress that contours to body shape for personalized support.',
    features: ['Memory Foam', 'Body Contouring', 'Pressure Relief', 'Motion Isolation', '6" & 8" Available'],
    sizes: ['72x30"', '72x42"', '72x48"', '72x60"', '75x48"', '75x60"'],
    images: [
      '/eclipse-products/catalogue/page24_img02.webp',
      '/eclipse-products/catalogue/page12_img01.webp',
      '/eclipse-products/catalogue/page14_img02.webp'
    ]
  },
];

// ==================== BLANKETS & COMFORTERS ====================
export const blanketProducts = [
  { 
    id: 'blanket-signature-mink',
    name: 'Signature Mink Double', 
    type: 'Mink Blanket', 
    brand: 'Signature', 
    bestseller: true,
    category: 'blankets',
    description: 'Luxuriously soft mink blanket for cold winters.',
    features: ['Super Soft Mink', 'Lightweight Warmth', 'Double Size', 'Machine Washable'],
    images: ['/generated-images/blanket-signature-mink/blanket-signature-mink-1.png', '/generated-images/blanket-signature-mink/blanket-signature-mink-2.png', '/generated-images/blanket-signature-mink/blanket-signature-mink-3.png']
  },
  { 
    id: 'blanket-microfill-comforter',
    name: 'Microfill Comforter', 
    type: 'Comforter', 
    brand: 'Premium', 
    bestseller: true,
    category: 'blankets',
    description: 'Lightweight microfill comforter with excellent warmth and breathability.',
    features: ['Microfill', 'Lightweight', 'Breathable', 'All Season'],
    images: ['/generated-images/blanket-signature-comfy/blanket-signature-comfy-1.png', '/generated-images/blanket-signature-comfy/blanket-signature-comfy-2.png', '/generated-images/blanket-signature-comfy/blanket-signature-comfy-3.png']
  },
  { 
    id: 'blanket-standard',
    name: 'Standard Blanket', 
    type: 'Blanket', 
    brand: 'Various', 
    bestseller: false,
    category: 'blankets',
    description: 'Classic blanket for everyday use. Warm and comfortable.',
    features: ['Classic Design', 'Warm', 'Comfortable', 'Multiple Colors'],
    images: ['/generated-images/blanket-golden-uno-floral/blanket-golden-uno-floral-1.png', '/generated-images/blanket-golden-uno-floral/blanket-golden-uno-floral-2.png', '/generated-images/blanket-golden-uno-floral/blanket-golden-uno-floral-3.png']
  },
  { 
    id: 'dohar-cotton',
    name: 'Cotton Dohar', 
    type: 'Dohar', 
    brand: 'Various', 
    bestseller: true,
    category: 'blankets',
    description: 'Light cotton dohar perfect for mild winters and AC rooms.',
    features: ['Pure Cotton', 'Lightweight', 'AC Friendly', 'Reversible'],
    images: ['/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-3.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-1.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-2.png']
  },
  { 
    id: 'dohar-printed',
    name: 'Printed Dohar', 
    type: 'Dohar', 
    brand: 'Various', 
    bestseller: false,
    category: 'blankets',
    description: 'Printed dohar with beautiful patterns for summer nights.',
    features: ['Printed Design', 'Summer Use', 'Beautiful Patterns', 'Soft'],
    images: ['/generated-images/bedsheet-mytrident-utsav/bedsheet-mytrident-utsav-3.png', '/generated-images/bedsheet-mytrident-utsav/bedsheet-mytrident-utsav-1.png', '/generated-images/bedsheet-mytrident-utsav/bedsheet-mytrident-utsav-2.png']
  },
];

// ==================== MATS ====================
export const matProducts = [
  { 
    id: 'mat-door',
    name: 'Door Mat', 
    type: 'Door Mat', 
    brand: 'Various', 
    bestseller: true,
    category: 'mats',
    description: 'Durable door mat for entrance. Keeps dirt outside.',
    features: ['Entrance Use', 'Dirt Trapping', 'Durable', 'Easy Clean'],
    images: ['/generated-images/mat-brown-coir/mat-brown-coir-1.png', '/generated-images/mat-brown-coir/mat-brown-coir-2.png', '/generated-images/mat-brown-coir/mat-brown-coir-3.png']
  },
  { 
    id: 'mat-bath',
    name: 'Bath Mat', 
    type: 'Bath Mat', 
    brand: 'Various', 
    bestseller: true,
    category: 'mats',
    description: 'Soft bath mat for bathroom use. Non-slip and absorbent.',
    features: ['Non-Slip', 'Absorbent', 'Soft Feel', 'Quick Dry'],
    images: ['/generated-images/mat-cushion-noodle/mat-cushion-noodle-1.png', '/generated-images/mat-cushion-noodle/mat-cushion-noodle-2.png', '/generated-images/mat-cushion-noodle/mat-cushion-noodle-3.png']
  },
  { 
    id: 'mat-shower',
    name: 'Shower Mat', 
    type: 'Shower Mat', 
    brand: 'Obsession', 
    bestseller: true,
    category: 'mats',
    description: 'Anti-slip shower mat for safety in wet conditions.',
    features: ['Anti-Slip', 'Suction Cups', 'Water Resistant', 'Safe'],
    images: ['/generated-images/mat-obsession-shower/mat-obsession-shower-1.png', '/generated-images/mat-obsession-shower/mat-obsession-shower-2.png', '/generated-images/mat-obsession-shower/mat-obsession-shower-3.png']
  },
  { 
    id: 'mat-yoga-4mm',
    name: 'Yoga Mat 4mm', 
    type: 'Yoga Mat', 
    brand: 'Various', 
    bestseller: false,
    category: 'mats',
    description: 'Lightweight 4mm yoga mat for basic yoga and exercises.',
    features: ['4mm Thickness', 'Lightweight', 'Portable', 'Non-Slip'],
    images: ['/generated-images/mat-black-hollow/mat-black-hollow-1.png', '/generated-images/mat-black-hollow/mat-black-hollow-2.png', '/generated-images/mat-black-hollow/mat-black-hollow-3.png']
  },
  { 
    id: 'mat-yoga-6mm',
    name: 'Yoga Mat 6mm', 
    type: 'Yoga Mat', 
    brand: 'Various', 
    bestseller: true,
    category: 'mats',
    description: 'Standard 6mm yoga mat with good cushioning for regular practice.',
    features: ['6mm Thickness', 'Good Cushioning', 'Standard Size', 'Comfortable'],
    images: ['/generated-images/mat-black-hollow/mat-black-hollow-2.png', '/generated-images/mat-black-hollow/mat-black-hollow-1.png', '/generated-images/mat-black-hollow/mat-black-hollow-3.png']
  },
  { 
    id: 'mat-yoga-8mm',
    name: 'Yoga Mat 8mm', 
    type: 'Yoga Mat', 
    brand: 'Various', 
    bestseller: false,
    category: 'mats',
    description: 'Extra thick 8mm yoga mat for maximum cushioning and joint protection.',
    features: ['8mm Thickness', 'Extra Cushioning', 'Joint Protection', 'Premium'],
    images: ['/generated-images/mat-black-hollow/mat-black-hollow-3.png', '/generated-images/mat-black-hollow/mat-black-hollow-1.png', '/generated-images/mat-black-hollow/mat-black-hollow-2.png']
  },
];

// ==================== TABLE MATS ====================
export const tableMatProducts = [
  { 
    id: 'table-mat-set',
    name: 'Table Mat Set', 
    type: 'Table Mat', 
    brand: 'Various', 
    bestseller: true,
    category: 'tableMats',
    description: 'Elegant table mat set for dining table decoration and protection.',
    features: ['Set of 6', 'Heat Resistant', 'Easy Clean', 'Elegant Design'],
    images: ['/generated-images/mat-brown-coir/mat-brown-coir-2.png', '/generated-images/mat-brown-coir/mat-brown-coir-1.png', '/generated-images/mat-brown-coir/mat-brown-coir-3.png']
  },
  { 
    id: 'table-mat-woven',
    name: 'Woven Table Mat', 
    type: 'Table Mat', 
    brand: 'Various', 
    bestseller: false,
    category: 'tableMats',
    description: 'Handwoven table mat with natural texture and appeal.',
    features: ['Handwoven', 'Natural Texture', 'Eco-Friendly', 'Unique Design'],
    images: ['/generated-images/mat-brown-coir/mat-brown-coir-3.png', '/generated-images/mat-brown-coir/mat-brown-coir-1.png', '/generated-images/mat-brown-coir/mat-brown-coir-2.png']
  },
];

// ==================== BABY PRODUCTS ====================
export const babyProducts = [
  { 
    id: 'baby-dry-sheet-small',
    name: 'Baby Dry Sheet - Small', 
    type: 'Dry Sheet', 
    brand: 'Various', 
    bestseller: true,
    category: 'babyProducts',
    description: 'Waterproof baby dry sheet to protect mattress from spills and leaks.',
    features: ['Waterproof', 'Soft Surface', 'Breathable', 'Washable'],
    images: ['/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-1.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-2.png', '/generated-images/bedsheet-mytrident-dusk/bedsheet-mytrident-dusk-3.png']
  },
  { 
    id: 'baby-dry-sheet-large',
    name: 'Baby Dry Sheet - Large', 
    type: 'Dry Sheet', 
    brand: 'Various', 
    bestseller: false,
    category: 'babyProducts',
    description: 'Large waterproof baby dry sheet for complete bed protection.',
    features: ['Large Size', 'Waterproof', 'Full Coverage', 'Gentle on Skin'],
    images: ['/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-3.png', '/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-1.png', '/generated-images/bedsheet-bombay-dyeing-double/bedsheet-bombay-dyeing-double-2.png']
  },
];

// ==================== SOFA PRODUCTS ====================
export const sofaProducts = [
  { 
    id: 'sofa-cushion-standard',
    name: 'Sofa Cushion', 
    type: 'Sofa Cushion', 
    brand: 'Various', 
    bestseller: true,
    category: 'sofaProducts',
    description: 'Comfortable sofa cushion for enhanced seating comfort.',
    features: ['Firm Support', 'Durable', 'Shape Retention', 'Various Sizes'],
    images: ['/generated-images/pillow-recron-elita/pillow-recron-elita-2.png', '/generated-images/pillow-recron-elita/pillow-recron-elita-1.png', '/generated-images/pillow-recron-elita/pillow-recron-elita-3.png']
  },
  { 
    id: 'sofa-material-foam',
    name: 'Sofa Material / Foam', 
    type: 'Sofa Material', 
    brand: 'Various', 
    bestseller: false,
    category: 'sofaProducts',
    description: 'High-quality foam material for sofa repair and upholstery.',
    features: ['High Density', 'Custom Cut', 'Durable', 'Multiple Densities'],
    images: ['/generated-images/pillow-recron-plush/pillow-recron-plush-3.png', '/generated-images/pillow-recron-plush/pillow-recron-plush-1.png', '/generated-images/pillow-recron-plush/pillow-recron-plush-2.png']
  },
];

// Get all products as a flat array
export const getAllProducts = () => {
  return [
    ...pillowProducts,
    ...cushionProducts,
    ...bolsterProducts,
    ...bedsheetProducts,
    ...towelProducts,
    ...mattressProducts,
    ...blanketProducts,
    ...matProducts,
    ...tableMatProducts,
    ...babyProducts,
    ...sofaProducts,
  ];
};

// Get product by ID
export const getProductById = (productId) => {
  const allProducts = getAllProducts();
  return allProducts.find(product => product.id === productId) || null;
};

export const getProductsByCategory = (categoryId) => {
  switch(categoryId) {
    case 'pillows': return pillowProducts;
    case 'cushions': return cushionProducts;
    case 'bolsters': return bolsterProducts;
    case 'bedsheets': return bedsheetProducts;
    case 'towels': return towelProducts;
    case 'mattresses': return mattressProducts;
    case 'blankets': return blanketProducts;
    case 'mats': return matProducts;
    case 'tableMats': return tableMatProducts;
    case 'babyProducts': return babyProducts;
    case 'sofaProducts': return sofaProducts;
    default: return [];
  }
};

// Get product images with fallback to category default or placeholder
export const getProductImages = (product) => {
  if (product?.images && product.images.length > 0) {
    return product.images;
  }
  
  if (product?.category && productCategories[product.category]?.defaultProductImage) {
    return [productCategories[product.category].defaultProductImage];
  }
  
  return [PLACEHOLDER_IMAGE];
};
